export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a5f00e25043c41992ad1a32a4933922c69d0663c&name=revalidateCommunity!'